import { ChangeEventHandler, MouseEventHandler } from 'react'
import {
  CheckCircleIcon,
  ExclamationTriangleIcon,
  InformationCircleIcon,
} from '@heroicons/react/24/solid'
import Tooltip from '@/components/common/Tooltip'
import { className } from '@/components/common/styles'

interface LabelProps {
  id: string
  label: string
  type?: string
  value?: string
  disabled?: boolean
  checked?: boolean
  placeholder?: string
  onChange?: ChangeEventHandler
  populate?: React.ReactNode // @@TODO: Verify correct type
  tooltip?: string
  icon?: 'check-circle' | 'exclamation-triangle' | 'info-circle'
  iconcolor?: string
  ttid?: string
  button?: string
  buttonaction?: MouseEventHandler<HTMLButtonElement>
}

function Label(label: Readonly<LabelProps>) {
  return (
    <div className="bg-slate-50 dark:bg-slate-900 text-black dark:text-white">
      <div>
        <label
          htmlFor={label.id}
          className="flex h-5 my-1 py-0 text-sm text-gray-600 dark:text-gray-400"
        >
          {label.label}
          {label.tooltip && (
            <Tooltip message={label.tooltip}>
              {label.icon === 'check-circle' && (
                <CheckCircleIcon className="text-green-500 h-5 w-5 mt-0 mx-1" />
              )}
              {label.icon === 'info-circle' && (
                <InformationCircleIcon className="text-blue-500 h-5 w-5 mt-0 mx-1" />
              )}
              {label.icon === 'exclamation-triangle' && (
                <ExclamationTriangleIcon className="text-red-500 h-5 w-5 mt-0 mx-1" />
              )}
            </Tooltip>
          )}
        </label>
      </div>
      {/* input text */}
      {(label.type === undefined || label.type === 'password') && (
        <div>
          <input
            className="w-full bg-slate-50 dark:bg-slate-800 rounded-md shadow-inner border border-slate-300 dark:border-slate-700 px-3 py-1 focus:ring-offset-0 focus:ring-4 focus:ring-blue-300 disabled:bg-slate-100 dark:disabled:bg-slate-700 disabled:cursor-not-allowed"
            id={label.id}
            name={label.id}
            value={label.value}
            disabled={label.disabled}
            placeholder={label.placeholder}
            onChange={label.onChange}
            type={label.type} // @@BUG: 20231225: bug with Server Action FormData
          />
          <div className="mb-4 mt-1">
            {label.button && (
              <button
                type="button"
                onClick={label.buttonaction}
                className={className}
              >
                {label.button}
              </button>
            )}
          </div>
        </div>
      )}
      {label.type === 'checkbox' && (
        <div>
          <input
            className="border-slate-300 mt-3 hover:cursor-pointer"
            id={label.id}
            name={label.id}
            disabled={label.disabled}
            type="checkbox"
            onChange={label.onChange}
          />
        </div>
      )}
      {label.type === 'select' && (
        <div>
          <select
            className="block appearance-none w-full bg-slate-50 dark:bg-slate-800 rounded-md shadow-inner border border-slate-300 dark:border-slate-700 px-3 py-1 focus:ring-offset-0 focus:ring-4 focus:ring-blue-300 mb-4 hover:cursor-pointer"
            id={label.id}
            name={label.id}
            disabled={label.disabled}
            value={label.value}
            //placeholder={label.placeholder}
            onChange={label.onChange}
          >
            {label.populate}
          </select>
        </div>
      )}
    </div>
  )
}

export default Label
